import React from "react";
import { Title, Text, Divider, Box, MantineTheme } from "@mantine/core";

export interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
  alert?: React.ReactNode;
  withoutDivider?: boolean;
}

export function PageHeader({
  title,
  subtitle,
  action,
  alert,
  withoutDivider = false,
}: PageHeaderProps) {
  return (
    <Box mb="sm">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "1rem",
          marginBottom: subtitle ? "0.35rem" : "0.75rem",
        }}
      >
        <div>
          <Title
            order={2}
            sx={(theme: MantineTheme) => ({
              fontSize: theme.headings.sizes.h4.fontSize,
              fontWeight: 600,
              color: theme.colors.dark[7] || "#1A1B1E",
              letterSpacing: "-0.01em",
              lineHeight: 1.3,
            })}
          >
            {title}
          </Title>
          {subtitle && (
            <Text
              size="xs"
              color="dimmed"
              mt={2}
              sx={{ fontStyle: "normal" }}
            >
              {subtitle}
            </Text>
          )}
        </div>
        {action && (
          <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flexWrap: "wrap" }}>
            {action}
          </div>
        )}
      </div>

      {alert && (
        <Box my="sm">
          {alert}
        </Box>
      )}

      {!withoutDivider && <Divider my="sm" />}
    </Box>
  );
}

export default PageHeader;
